import Api from '@/api/Api'

const profileImage = {
  namespaced: true,
  state: {
    image: null
  },
  actions: {
    load ({ commit }) {
      return Api().get('User/Image')
        .then((r) => {
          if (r.data && r.data.content) {
            commit('setImage', 'data:' + r.data.contentType + ';base64,' + r.data.content)
          } else {
            commit('setImage', null)
          }
        })
    },
    upload ({ commit }, image) {
      var formData = new FormData()
      console.log(image)
      formData.append('file', image)
      console.log(formData)
      return Api().post('User/Image', formData)
        .then((r) => {
          if (r.data && r.data.content) {
            commit('setImage', 'data:' + r.data.contentType + ';base64,' + r.data.content)
          } else {
            commit('setImage', null)
          }
        })
    }
  },
  mutations: {
    setImage (state, image) {
      state.image = image
    }
  }
}

export default profileImage
